interface IConfig {
  apiBaseUrl: string;
  translationUrl: string;
  clientId: string;
  redirectUri: string;
}
const appConfig = (window as any).APP_CONFIG;

export const config: IConfig = {
  apiBaseUrl: `${appConfig.apiBaseUrl}/api`,
  translationUrl: `${appConfig.apiBaseUrl}/translations/web/{{lng}}.json`,
  clientId: appConfig.clientId as string,
  redirectUri: window.location.origin,
};
